import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const cashflowPriceAuditControl: DomainAccessControlConfig = {
  permissions: [Permission.CashflowCatalogAuditView],
}

export const cashflowCheckoutDiscrepancyAuditControl: DomainAccessControlConfig = {
  permissions: [Permission.CashflowCatalogAuditView],
  featureToggles: FeatureToggle.cashflowCheckoutDiscrepancyAudits,
}

export const cashflowTransactionIntegrityAuditControl: DomainAccessControlConfig = {
  permissions: [Permission.CashflowCatalogAuditView, Permission.CatalogProductsView],
}
